module.exports = __webpack_public_path__ + "img/defaultrt.bbfaa97a.png";